import React from "react";
import { useTranslation } from "react-i18next";
import { useFeedContext } from "../../helpers/feed/FeedContextProvider";
import { Skeleton } from "@mui/material";
import FacebookPostEmbed from "../FacebookPostEmbed";

const LatestNews = () => {
  const { t } = useTranslation();
  const { recentFeed } = useFeedContext();

  return (
    <section className="relative w-full h-full ">
      <div className="w-full bg-[#F2F6F7] px-[5%]">
        <div className="pt-16 pb-12 md:pt-20 sm:pb-24 maxContainer ">
          <h2 className="mt-2 mb-5 font-bold leading-tight text-[28px] ss:text-md md:text-lg md:max-w-[599px] tracking-wide">
            {t("recents.heading")}
          </h2>
          <p className="md:text-[18px] text-greyText">
            {t("recents.description")}
          </p>
        </div>
      </div>

      <div className="px-[5%] ">
        <div className="pb-8 md:pb-20 maxContainer ">
          <div className="relative flex flex-wrap justify-center gap-12 sm:gap-8 ">
            {!recentFeed.length &&
              Array.from(Array(4)).map((_, idx) => (
                <Skeleton
                  key={idx}
                  variant="rectangular"
                  sx={{ width: "100%", height: "247px" }}
                />
              ))}

            {!!recentFeed.length &&
              recentFeed.map((post, idx) => (
                <FacebookPostEmbed key={idx} postUrl={post.permalink_url} />
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
